import moment from "moment";
import React, { useEffect, useState } from "react";
import { Bar, Line } from "react-chartjs-2";
import { useCentralStore } from "../../store/appContext";
import ActionTypes from "../../store/actionTypes";
import API from "../../api";
import resources from "../../components/common/resources.json";
import { sortTenureCategoriesForCustValMgmt } from "../../utils/functionUtils";

const CustomerValueManagement = ({ }) => {
    const [{ carrierThemeData, userData, userDetails, projectName }, dispatch] = useCentralStore()
    const { theme } = carrierThemeData;

    const [chartDetails, setChartDetails] = useState({})

    const SHORT_SYMBOLS = ["", "K", "M", "B", "T", "Q"];
    const abbreviateNumberFactory = (symbols) => (
        (number, minDigits, maxDigits) => {

            if (number >= 0.01 && number <= 0.99) return number;

            if (number === 0) return number;

            // determines SI symbol
            const tier = Math.floor(Math.log10(Math.abs(number)) / 3);

            // get suffix and determine scale
            const suffix = symbols[tier];
            const scale = 10 ** (tier * 3);

            // scale the number
            const scaled = number / scale;

            // format number and add suffix
            return scaled.toLocaleString(undefined, {
                minimumFractionDigits: minDigits,
                maximumFractionDigits: maxDigits,
            }) + suffix;
        }
    );

    // const abbreviateNumberSI = abbreviateNumberFactory(SI_SYMBOLS);
    const abbreviateNumberShort = abbreviateNumberFactory(SHORT_SYMBOLS);
    let abbreviateNumberShortConvert = (value) => {
        return value ? abbreviateNumberShort(value, 0, 2) : 0;
    }

    const setLoading = (action) => {
        dispatch({ type: ActionTypes.SET_LOADING, payload: action });
      };

    useEffect(() => {
        let payload = {}
        setLoading(true);
        API[ActionTypes.GET_CELCOM_CUSTOMER_VALUE_MGMT_DETAILS](payload, userData?.access_token, userDetails && userDetails?.email?.split("@")?.[0])
            .then(({ data }) => {
                setLoading(false);
                if (data) {
                    // console.log('data?.GetCustomerValueManagementResponse', data?.GetCustomerValueManagementResponse);
                    // dispatch({ type: ActionTypes.SET_CELCOM_CUSTOMER_VALUE_MGMT_DATA, data: data?.GetCustomerValueManagementResponse });
                    setChartDetails(data?.GetCustomerValueManagementResponse)
                }
            })
            .catch((err) => {
                setLoading(false);
                dispatch({ type: ActionTypes.SET_API_ERROR, data: true });
                let _payload = {
                    level: resources.POST_LOGGER_ERROR,
                    category: resources.POST_LOGGER_API,
                    ApiName: resources.POST_LOGGER_APINAME,
                    message: {
                        error: err,
                        info: {
                            idToken: "",
                        },
                    },
                };
                API[ActionTypes.POST_LOGGER](_payload, userData?.access_token, userDetails && userDetails?.email?.split("@")?.[0]);
            });
    }, [])

    // Chrun By Rate
    let churnByRate = chartDetails?.churnByRate;
    const getUniqueChurnByRateValues = (arr) => {
        const uniqueYears = [...new Set(arr)];
        return uniqueYears;
    };

    let churnByRateYears = getUniqueChurnByRateValues(churnByRate?.map(v => v?.Year));
    let churnByRateMonths = getUniqueChurnByRateValues(churnByRate?.map(v => moment(v?.Month).format('MMM')));
    let _chrunRate = churnByRateYears?.map((year, i) => { return { [year]: churnByRate?.map(v => { return v.Year === year ? v.ChurnRate : '' })?.filter(v => v !== '') } })
    let chrunRateData = []

    churnByRateYears?.map((year, i) => {
        chrunRateData.push({
            year: year,
            label: Object.keys(_chrunRate[i]),
            data: _chrunRate[i][year],
            fill: true,
            backgroundColor: theme?.colors?.monthlyTrendsTab?.chartColorsNew[i],
            borderColor: theme?.colors?.monthlyTrendsTab?.chartColorsNew[i]
        })
    })
    const OverallChurnRateData = {
        labels: churnByRateMonths,
        datasets: chrunRateData.sort((a, b) => a.year - b.year)
    };

    const OverallChurnRateOptions = {
        plugins: {
            title: {
                display: true,
                text: 'Overall Churn Rate',
                align: 'start',
                font: {
                size: 20,
                },
            },
            legend: {
                align: 'end',
                position: 'top',
                labels: {
                  font: {
                    weight: 500,
                    color: 'black',
                    size: 14,
                  }
                }
              },
            datalabels: {
                formatter: function (value, context) {
                    return value > 0 ? value+'%' : null;
                },
                align: function (value, context) {
                    return Number(value?.dataset?.label) % 2 === 0 ? 'top' : 'bottom'
                },
                anchor: "end",
                labels: {
                    usePointStyle: true,
                    font: {
                        weight: 700,
                        color: "black",
                        size: 14,
                    },
                },
            }
        },
        responsive: true,
        scales: {
            x: {
                stacked: false,
                grid: {
                    display:false
                }
            },
            y: {
                stacked: false,
                grid: {
                    display:false
                }
            },
        },
        // barThickness: 15
    };

    // Churn By Nature
    let churnByNature = chartDetails?.churnByNature;

    let churnByNatureDataset = []
    churnByNature?.map((v, i) => {
         let rs= v && v.Year;
         v.year= rs?.split('-')?.[1]
    });
    churnByNature && churnByNature.sort((a, b) => a.year - b.year)

    churnByNature?.map((v, i) => {
        churnByNatureDataset?.push({
            label: v?.Year,
            data: [v?.RemorseChurnPercentage || 0, v?.MidContractChurnPercentage || 0, v?.UpgradeChurnPercentage || 0],
            fill: true,
            backgroundColor: theme?.colors?.monthlyTrendsTab?.chartColorsNew[i],
            borderColor: theme?.colors?.monthlyTrendsTab?.chartColorsNew[i]
        })
    })
    const ChurnNatureData = {
        labels: ['Remorse (<=3 months)', 'Mid Contract (4 - 23 months)', 'Upgrade (>=24 months)'],
        datasets: churnByNatureDataset.sort((a, b) => a.year - b.year)
    };

    const ChurnNatureOptions = {
        plugins: {
            title: {
                display: true,
                text: 'Churn Nature',
                align: 'start',
                font: {
                size: 20,
                },
            },
            legend: {
                align: 'end',
                position: 'top',
                labels: {
                  font: {
                    weight: 500,
                    color: 'black',
                    size: 14,
                  }
                }
              },
            datalabels: {
                formatter: function (value, context) {
                    return value > 0 ? value + '%' : null;
                },
                align: "top",
                anchor: "end",
                clamp: false,
                labels: {
                    usePointStyle: true,
                    font: {
                        weight: 700,
                        color: 'black',
                        size: 16,
                    }
                },
            }
        },
        responsive: true,
        scales: {
            x: {
                stacked: false,
                grid: {
                    display:false
                }
            },
            y: {
                stacked: false,
                grid: {
                    display:false
                }
            },
        },
        // barThickness: 15
    };

    //Churn By Program
    let churnByProgram = chartDetails?.churnByProgram;
    churnByProgram?.map((v, i) => {
          let rs= v && v.Year;
         v.year= rs?.split('-')?.[1]
    });
    churnByProgram && churnByProgram.sort((a, b) => a.year - b.year)

    let churnByProgramData = {
        Program: [...new Set(churnByProgram?.map((v) => v?.["Program"]))],
        Year: [...new Set(churnByProgram?.map((v) => v?.Year))],
    }

    const getChurnByYearData = (year, programs) => {
        let data = []
        for (let i = 0; i < programs?.length; i++) {
            let c = churnByProgram?.filter(v => v?.Program === programs[i])
            data.push(c?.find(v => v?.Year === year)?.ChurnByProgram || 0)
        }
        return data//churnByProgram?.filter(v => v?.Year === year)?.map(v => v?.ChurnByProgram || 0)
    }

    let churnByProgramDataset = []

    churnByProgramData?.Year?.map((v, i) => {
        churnByProgramDataset?.push({
            label: v,
            data: getChurnByYearData(v, churnByProgramData?.Program),
            fill: true,
            backgroundColor: theme?.colors?.monthlyTrendsTab?.chartColorsNew[i],
            borderColor: theme?.colors?.monthlyTrendsTab?.chartColorsNew[i]
        })
    })

    const churnProgramData = {
        labels: churnByProgramData?.Program,
        datasets: churnByProgramDataset.sort((a, b) => a.year - b.year)
    };

    const churnProgramOptions = {
        indexAxis: 'y',
        plugins: {
            title: {
                display: true,
                text: 'Churn by Program',
                align: 'start',
                font: {
                size: 20,
                },
            },
            legend: {
                align: 'end',
                position: 'top',
                labels: {
                  font: {
                    weight: 500,
                    color: 'black',
                    size: 14,
                  }
                }
              },
            bar: {
                borderWidth: 2,
            },
            datalabels: {
                formatter: function (value, context) {
                    return value > 0 ? value+'%' : null;
                },
                align: "right",
                anchor: "end",
                labels: {
                    usePointStyle: true,
                    font: {
                        weight: 700,
                        color: 'black',
                        size: 12,
                    }
                },
            }
        },
        responsive: true,
        scales: {
            x: {
                stacked: false,
                grid: {
                    display:false
                }
            },
            y: {
                stacked: false,
                grid: {
                    display:false
                }
            },
        },
        // barThickness: 15
    }

    // Churn By Device Tier
    let churnByDeviceTier = chartDetails?.churnByDeviceTier;
    churnByDeviceTier?.map((v, i) => {
        let rs= v && v.Year;
         v.year= rs?.split('-')?.[1]
    });
    churnByDeviceTier && churnByDeviceTier.sort((a, b) => a.year - b.year)

    let churnByDeviceTierData = {
        Tier: [...new Set(churnByDeviceTier?.map((v) => 'Tier '+v?.["Tier"]))],
        Year: [...new Set(churnByDeviceTier?.map((v) => v?.Year))],
    }

    const getChurnByDeviceTierData = (year, tiers) => {
        let data = []
        for (let i = 0; i < tiers?.length; i++) {
            let c = churnByDeviceTier?.filter(v => 'Tier '+v?.Tier === tiers[i])
            data.push(c?.find(v => v?.Year === year)?.ChurnByDeviceTiers || 0)
        }
        return data
    }

    let churnByDeviceTierDataset = []

    churnByDeviceTierData?.Year?.map((v, i) => {
        churnByDeviceTierDataset?.push({
            label: v,
            data: getChurnByDeviceTierData(v, churnByDeviceTierData?.Tier),
            fill: true,
            backgroundColor: theme?.colors?.monthlyTrendsTab?.chartColorsNew[i],
            borderColor: theme?.colors?.monthlyTrendsTab?.chartColorsNew[i]
        })
    })
    const DeviceTierData = {
        labels: churnByDeviceTierData?.Tier,
        datasets: churnByDeviceTierDataset.sort((a, b) => a.year - b.year)
    };

    const DeviceTierOptions = {
        plugins: {
            title: {
                display: true,
                text: 'Churn by Device Tier',
                align: 'start',
                font: {
                size: 20,
                },
            },
            legend: {
                align: 'end',
                position: 'top',
                labels: {
                  font: {
                    weight: 500,
                    color: 'black',
                    size: 14,
                  }
                }
              },
            datalabels: {
                formatter: function (value, context) {
                    return value > 0 ? value+'%' : null; 
                },
                align: "top",
                anchor: "end",
                clamp: false,
                labels: {
                    usePointStyle: true,
                    font: {
                        weight: 700,
                        color: 'black',
                        size: 16,
                    }
                },
            }
        },
        responsive: true,
        scales: {
            x: {
                stacked: false,
                grid: {
                    display:false
                }
            },
            y: {
                stacked: false,
                grid: {
                    display:false
                }
            },
        },
        // barThickness: 15
    };

    // Churn By Phone Make
    let churnByPhoneMake = chartDetails?.churnByPhoneMake;
    churnByPhoneMake?.map((v, i) => {
        let rs= v && v.Year;
        v.year= rs?.split('-')?.[1]
    });
    churnByPhoneMake && churnByPhoneMake.sort((a, b) => a.year - b.year)


    let churnByPhoneMakeData = {
        PhoneMake: [...new Set(churnByPhoneMake?.map((v) => v?.["PhoneMake"]))],
        Year: [...new Set(churnByPhoneMake?.map((v) => v?.Year))],
    }

    const getChurnByPhoneMakeData = (year, PhoneMake) => {
        let data = []
        for (let i = 0; i < PhoneMake?.length; i++) {
            let c = churnByPhoneMake?.filter(v => v?.PhoneMake === PhoneMake[i])
            data.push(c?.find(v => v?.Year === year)?.ChurnByDeviceBrand || 0)
        }
        return data
    }

    let churnByDeviceBrandDataset = []

    churnByDeviceTierData?.Year?.map((v, i) => {
        churnByDeviceBrandDataset?.push({
            label: v,
            data: getChurnByPhoneMakeData(v, churnByPhoneMakeData?.PhoneMake),
            fill: true,
            backgroundColor: theme?.colors?.monthlyTrendsTab?.chartColorsNew[i],
            borderColor: theme?.colors?.monthlyTrendsTab?.chartColorsNew[i]
        })
    })

    
    const phoneMakeData = {
        labels: churnByPhoneMakeData?.PhoneMake,
        datasets: churnByDeviceBrandDataset.sort((a, b) => a.year - b.year)
    };

    const phoneMakeOptions = {
        // indexAxis: 'x',
        plugins: {
            title: {
                display: true,
                text: 'Churn by Phone Make',
                align: 'start',
                font: {
                size: 20,
                },
            },
            legend: {
                align: 'end',
                position: 'top',
                labels: {
                  font: {
                    weight: 500,
                    color: 'black',
                    size: 14,
                  }
                }
              },
            bar: {
                borderWidth: 2,
            },
            datalabels: {
                formatter: function (value, context) {
                    // return value > 0 ? value : null;
                    return abbreviateNumberShortConvert(value, 0, 2);
                },
                align: "top",
                anchor: "end",
                font: {
                    size: 10
                },
                labels: {
                    usePointStyle: true,
                    font: {
                        weight: 700,
                        color: 'black',
                        // size: 12,
                    }
                },
            }
        },
        responsive: true,
        scales: {
            x: {
                stacked: false,
                grid: {
                    display:false
                }
            },
            y: {
                stacked: false,
                grid: {
                    display:false
                }
            },
        },
        // barThickness: 15
    }

    // Churn By Tenure Days
    let churnByTenureDays = chartDetails?.churnByTenureDays;
    churnByTenureDays?.map((v, i) => {
        let rs= v && v.Year;
        v.year= rs?.split('-')?.[1]
    });
    churnByTenureDays && churnByTenureDays.sort((a, b) => a.year - b.year)

    let churnByTenureDaysData = {
        Category: [...new Set(churnByTenureDays?.map((v) => v?.["Category"]))],
        Year: [...new Set(churnByTenureDays?.map((v) => v?.Year))],
    }

    const sortedTenureCategories = sortTenureCategoriesForCustValMgmt(churnByTenureDaysData?.Category);

    const getChurnByTenureDaysData = (year, Category) => {
        let data = []
        for (let i = 0; i < Category?.length; i++) {
            let c = churnByTenureDays?.filter(v => v?.Category === Category[i])
            data.push(c?.find(v => v?.Year === year)?.ChurnByTenureDays || 0)
        }
        return data
    }

    let churnByTenureDaysDataset = []

    churnByTenureDaysData?.Year?.map((v, i) => {
        churnByTenureDaysDataset?.push({
            label: v,
            data: getChurnByTenureDaysData(v, sortedTenureCategories),
            fill: true,
            backgroundColor: theme?.colors?.monthlyTrendsTab?.chartColorsNew[i],
            borderColor: theme?.colors?.monthlyTrendsTab?.chartColorsNew[i]
        })
    })
    
    const TenureDaysData = {
        labels: sortedTenureCategories,
        datasets: churnByTenureDaysDataset.sort((a, b) => a.year - b.year)
    };

    const TenureDaysOptions = {
        plugins: {
            title: {
                display: true,
                text: 'Churn By Tenure Days',
                align: 'start',
                font: {
                size: 20,
                },
            },
            legend: {
                align: 'end',
                position: 'top',
                labels: {
                  font: {
                    weight: 500,
                    color: 'black',
                    size: 14,
                  }
                }
              },
            datalabels: {
                formatter: function (value, context) {
                    return value > 0 ? value+'%' : null;
                },
                align: "top",
                anchor: "end",
                font: {
                    size: 10
                },
                clamp: false,
                labels: {
                    usePointStyle: true,
                    font: {
                        weight: 700,
                        color: 'black',
                        // size: 16,
                    }
                },
            }
        },
        responsive: true,
        scales: {
            x: {
                stacked: false,
                grid: {
                    display:false
                }
            },
            y: {
                stacked: false,
                grid: {
                    display:false
                }
            }
        },
        // barThickness: 15
    };

    return (
        <div className={`flex flex-wrap gap-5 ${projectName.replace(/\s+/g, '')}`}>
            <div className='flex flex-col items-center w-full border border-1 border-gray-200 rounded-lg p-4 pb-0'>
                {/* <p className='p-2 w-full text-black font-bold'>Overall Churn Rate</p> */}
                <div className='w-full'>
                    <Line options={OverallChurnRateOptions} data={OverallChurnRateData} />
                </div>
            </div>
            <div className='flex flex-col items-center w-full border border-1 border-gray-200 rounded-lg p-4 pb-0'>
                {/* <p className='p-2 w-full text-black font-bold'>Churn Nature</p> */}
                <div className='w-full'>
                    <Bar options={ChurnNatureOptions} data={ChurnNatureData} />
                </div>
            </div>
            <div className='flex flex-col items-center w-full border border-1 border-gray-200 rounded-lg p-4 pb-0'>
                {/* <p className='p-2 w-full text-black font-bold'>Churn By Tenure Days</p> */}
                <div className='w-full'>
                    <Bar options={TenureDaysOptions} data={TenureDaysData} />
                </div>
            </div>
            <div className='flex flex-col items-center w-full border border-1 border-gray-200 rounded-lg p-4 pb-0'>
                {/* <p className='p-2 w-full text-black font-bold'>Churn by Program</p> */}
                <div className='w-full'>
                    <Bar options={churnProgramOptions} data={churnProgramData} />
                </div>
            </div>
            <div className='flex flex-col items-center w-full border border-1 border-gray-200 rounded-lg p-4 pb-0'>
                {/* <p className='p-2 w-full text-black font-bold'>Churn by Device Tier</p> */}
                <div className='w-full'>
                    <Bar options={DeviceTierOptions} data={DeviceTierData} />
                </div>
            </div>
            <div className='flex flex-col items-center w-full border border-1 border-gray-200 rounded-lg p-4 pb-0'>
                {/* <p className='p-2 w-full text-black font-bold'>Churn by Phone Make</p> */}
                <div className='w-full'>
                    <Bar options={phoneMakeOptions} data={phoneMakeData} />
                </div>
            </div>
        </div>
    );
}

export default CustomerValueManagement